import React, { useState, useEffect } from 'react'

import Container from '../../atoms/Container'
import Row from '../../atoms/Row'
import Col from '../../atoms/Col'

import BrandLink from '../../atoms/Nav/BrandLink'
import Link from '../../atoms/Nav/Link'
import Logo from '../../atoms/Nav/Logo'
import Menu from '../../atoms/Nav/Menu'
import MenuItem from '../../atoms/Nav/MenuItem'
import Toggle from '../../atoms/Nav/Toggle'
import Background from '../../atoms/Nav/Background'
import FullscreenMenu from '../../atoms/Nav/FullscreenMenu'

export default ({ menu, logo, children }) => {
  const [show, setShow] = useState()

  // TODO: make a hook for disabling body scroll
  useEffect(() => {
    const classList = document.body.className.split(/ +/)
    const className = 'noscroll'

    const index = classList.indexOf(className)
    if (index > -1) classList.splice(index, 1)
    if (show) classList.push(className)

    document.body.className = classList.join(' ')
  }, [show])

  return (
    <>
      <Background>
        <Container>
          <Row>
            <Col flex='0 0 auto'>
              <BrandLink href={logo.url}>
                <Logo />
              </BrandLink>
            </Col>
            <Col>
              <Menu inline>
                {children ||
                  menu.slice(0, 1).map(({ title, href }, i) => (
                    <MenuItem key={i} hideOnMobile>
                      <Link href={href}>{title}</Link>
                    </MenuItem>
                  ))}
                <MenuItem toggle>
                  <Toggle open={show} onClick={() => setShow(!show)}>
                    Menu
                  </Toggle>
                </MenuItem>
              </Menu>
            </Col>
          </Row>
        </Container>
      </Background>
      {show ? (
        <FullscreenMenu>
          <Background>
            <Menu>
              {menu.map(({ title, href }, i) => (
                <MenuItem key={i}>
                  <Link href={href} onClick={() => setShow()}>
                    {title}
                  </Link>
                </MenuItem>
              ))}
            </Menu>
          </Background>
        </FullscreenMenu>
      ) : null}
    </>
  )
}
